

function Footer(props: {children: any}) {
    const { children } = props;
    return <div className="mafia-footer">{children}</div>
}

export default Footer;